import { render, staticRenderFns } from "./LearningStandards.vue?vue&type=template&id=a43fbdd0&scoped=true"
import script from "./LearningStandards.vue?vue&type=script&lang=js"
export * from "./LearningStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43fbdd0",
  null
  
)

export default component.exports